import React from 'react';
import PropTypes from 'prop-types';
import AppRoutes from './routes'; 
import { IntlProvider } from 'react-intl';
import { connect } from 'react-redux';
import languageObject from './translations/messages';
import { useNavigationTracker } from './hooks/useNavigationTracker';

import '@formatjs/intl-pluralrules/polyfill';
import '@formatjs/intl-pluralrules/locale-data/en'; // And any other locales you need


const handleIntlError = (error) => {
  if (process.env.NODE_ENV !== 'production') {
    // Only log in development
    if (error.code === 'MISSING_TRANSLATION') {
      //console.warn(`Missing translation: "${error.message}" for locale "${error.locale}"`);
      // You could also log missing translations to a collection for later review
    } else {
      console.error('Intl Error:', error);
    }
  }
  // Return false to use the default message or return a string to use as a fallback
  return false;
};

const App = props => {
  const { locale } = props.locale;
   useNavigationTracker();
  return (
    <IntlProvider locale={locale} messages={languageObject[locale]} onError={handleIntlError}  defaultLocale="en" >
      <AppRoutes />
    </IntlProvider>
  );
};

App.propTypes = {
  locale: PropTypes.object
};

const mapStateToProps = state => ({ locale: state.locale });

export default connect(mapStateToProps)(App);